__turbopack_context__.v({
  "gradient": "styles-module__22x_nW__gradient",
});
